import { assert } from '@ftr/contracts/shared/Assertions'
import { editToBumpUtteranceStartTime, SttEdit, SttUtterance } from '@ftr/regional-api-contracts'
import { Duration, LocalDateTime } from '@js-joda/core'
import { RealTimeSttSegmentMap } from '../../../types'

export const UNIQUE_START_TIME_BUMP_DURATION: Duration = Duration.ofMillis(1)

export function bumpStartTimeEditsToProduceUniqueTime(
  reservedTime: LocalDateTime,
  segmentMap: RealTimeSttSegmentMap,
  bumpDirection: 'forward' | 'backward',
): SttEdit[] {
  const remarkAtReservedTime = segmentMap
    .getSegmentAt(reservedTime)
    ?.remarksArray.find(x => x.startTime.equals(reservedTime))
  if (!remarkAtReservedTime) {
    return []
  }

  assert(remarkAtReservedTime.fragments && remarkAtReservedTime.fragments.length)

  const utterance: Omit<SttUtterance, 'courtSystemId'> = {
    id: remarkAtReservedTime.id,
    sttSpeakerId: remarkAtReservedTime.speakerId!,
    dialect: remarkAtReservedTime.dialect,
    startTime: remarkAtReservedTime.startTime,
    endTime: remarkAtReservedTime.endTime,
    fragments: remarkAtReservedTime.fragments.map(frag => ({
      content: frag.content,
      offsetMs: Duration.between(remarkAtReservedTime.startTime, frag.startTime).toMillis(),
      durationMs: Duration.between(frag.startTime, frag.endTime).toMillis(),
    })),
  }

  const edit = editToBumpUtteranceStartTime(utterance, bumpDirection)
  // The edit will always be an upsert as this is the only way to change start time
  assert(edit.type === 'upsertUtterance')
  return [edit, ...bumpStartTimeEditsToProduceUniqueTime(edit.fragments[0].startTime, segmentMap, bumpDirection)]
}
